import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from "../../../api";
import { Row, Col } from 'reactstrap';

import moment from "moment";

import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import TableComidasPedidas from "./TableComidasPedidas.js"


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,

            codigoVerificacion: null,
            orden: "",
            fecha: null,
            menuDiarioCodigo: null,
            planta: "",
            lugarDeEntrega: "",
            responsable: null,
            persona: null,
            estado: null,

            entrada: [],
            menuPrincipal: [],
            guarnicion: [],
            ensaladas: [],
            complementos: [],
            postre: [],
            bebida: [],

            insumosAdjuntos: [],

            errors: [],
        };
    }

    static propTypes = {
        id: PropTypes.func,
        missingIdMessage: PropTypes.string,
        initOpen: PropTypes.func,
        action: PropTypes.oneOf(['DETAIL']).isRequired,
    }

    resetForm() {
        this.setState({
            id: null,

            codigoVerificacion: null,
            orden: "",
            fecha: null,
            menuDiarioCodigo: null,
            planta: "",
            lugarDeEntrega: "",
            responsable: null,
            persona: null,
            estado: null,

            entrada: [],
            menuPrincipal: [],
            guarnicion: [],
            ensaladas: [],
            complementos: [],
            postre: [],
            bebida: [],

            insumosAdjuntos: [],

            errors: [],
        });
    }

    setData(data) {
        // Request data de la api para cargar los detalles del pedido de vianda
        if (data.success) {
            const id = data.id ? data.id : null;
            const codigoVerificacion = data.codigo_verificacion ? data.codigo_verificacion : null;
            const orden = data.orden ? data.orden : "";
            const fecha = data.pedido_vianda_fecha ? data.pedido_vianda_fecha : null;
            const menuDiarioCodigo = data.menu_diario_codigo ? data.menu_diario_codigo : null;
            const planta = data.planta_nombre ? data.planta_nombre : "";
            const lugarDeEntrega = data.lugar_de_entrega ? data.lugar_de_entrega : "";
            const responsable = data.responsable ? data.responsable : null;
            const persona = data.persona ? data.persona : null;
            const estado = data.estado_nombre ? data.estado_nombre : null;
            // En los que viene una sola comida se encapsulan en una lista
            // para poder usar TableComidasPedidas fácilmente.
            const entrada = data.entrada ? [data.entrada] : [];
            const menuPrincipal = data.menu_principal ? [data.menu_principal] : [];
            const guarnicion = data.guarnicion ? [data.guarnicion] : [];
            const ensaladas = data.ensaladas ? data.ensaladas : [];
            const complementos = data.complementos ? data.complementos : [];
            const postre = data.postre ? [data.postre] : [];
            const bebida = data.bebida ? [data.bebida] : [];
            // Los insumos adjuntos al pedido de vianda. Vienen como
            // {descripcion, cantidad} y TableComidasPedidas lee 'nombre', igual
            // que el panel administrativo, que tambien los renombra al armar sus
            // filas (buildFilasInsumos en views/Pedidos/Modal.js).
            const insumosAdjuntos = (data.insumos_adjuntos ? data.insumos_adjuntos : []).map(insumo => ({
                nombre: insumo.descripcion,
                cantidad: insumo.cantidad,
            }));

            this.setState({
                id,
                codigoVerificacion,
                orden,
                fecha,
                menuDiarioCodigo,
                planta,
                lugarDeEntrega,
                responsable,
                persona,
                estado,

                entrada,
                menuPrincipal,
                guarnicion,
                ensaladas,
                complementos,
                postre,
                bebida,

                insumosAdjuntos,
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action, id } = this.props;
        if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                submitUrl: null,
                title: "Detalle del Pedido de Vianda",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                saveButtonLabel: null,
                buttonClass: "",
                disabled: true,
                id: id,
            };
        }
    }



    render() {
        const {
            codigoVerificacion,
            menuDiarioCodigo,
            orden,
            fecha,
            planta,
            lugarDeEntrega,
            responsable,
            persona,
            estado,

            entrada,
            menuPrincipal,
            guarnicion,
            ensaladas,
            complementos,
            postre,
            bebida,

            insumosAdjuntos,
        } = this.state;

        const {
            missingIdMessage,
        } = this.props;

        const vars = this.modalVars()
        const missingPedidoDetalleIdMessage = missingIdMessage ? missingIdMessage : "Debe seleccionar una fila.";

        let responsableNombreApellido = "";
        if (responsable){
            responsableNombreApellido = `${responsable.nombre}, ${responsable.apellido}`;
        }
        let personaNombreApellido = "";
        if (persona){
            personaNombreApellido = `${persona.nombre}, ${persona.apellido}`;
        }

        const fechaFormateada = fecha ? moment(fecha).format("DD/MM/YYYY") : "";

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.viandas.misPedidosDetalles : null)}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={missingPedidoDetalleIdMessage}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}

                className={'modal-lg'}
            >
                <Row>
                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Codigo Verificación"}
                            value={codigoVerificacion}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Orden"}
                            value={orden}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Fecha"}
                            value={fechaFormateada}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Estado"}
                            value={estado}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Planta"}
                            value={planta}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Lugar de Entrega"}
                            value={lugarDeEntrega}
                        />
                    </Col>

                    <Col className={'col-6'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Menú Diario"}
                            value={menuDiarioCodigo}
                        />
                    </Col>

                    <Col className={'col-12'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Responsable"}
                            value={responsableNombreApellido}
                        />
                    </Col>

                    <Col className={'col-12'}>
                        <ParadigmaLabeledInput
                            disabled={true}
                            md={[3, 9]}
                            label={"Persona"}
                            value={personaNombreApellido}
                        />
                    </Col>

                </Row>

                {/* Comidas del Menú Diario */}
                <Row>
                    {/* Entrada */}
                    <Col className={'col-12'}>
                    <Row className={'pl-1 pr-2'}>
                        <TableComidasPedidas 
                            titulo={"Entrada"}
                            comidas={entrada}
                        />
                    </Row>
                    </Col>

                    {/* Menu Principal */}
                    <Col className={'col-6'}>
                    <Row className={'pr-1'}>
                        <TableComidasPedidas 
                            titulo={"Menú Principal"}
                            comidas={menuPrincipal}
                        />
                    </Row>
                    </Col>

                    {/* Guarnicion */}
                    <Col className={'col-6'}>
                    <Row className={'pl-1 pr-2'}>
                        <TableComidasPedidas 
                            titulo={"Guarnicion"}
                            comidas={guarnicion}
                        />
                    </Row>
                    </Col>

                    {/* Ensaladas */}
                    <Col className={'col-6'}>
                    <Row className={'pl-1 pr-2'}>
                        <TableComidasPedidas 
                            titulo={"Ensaladas"}
                            comidas={ensaladas}
                        />

                    </Row>
                    </Col>

                    {/* Complementos */}
                    <Col className={'col-6'}>
                    <Row className={'pr-1'}>
                        <TableComidasPedidas 
                            titulo={"Complementos"}
                            comidas={complementos}
                        />
                    </Row>
                    </Col>

                    {/* Postre */}
                    <Col className={'col-6'}>
                    <Row className={'pr-1'}>
                        <TableComidasPedidas 
                            titulo={"Postre"}
                            comidas={postre}
                        />
                    </Row>
                    </Col>

                    {/* Bebida */}
                    <Col className={'col-6'}>
                    <Row className={'pl-1 pr-2'}>
                        <TableComidasPedidas
                            titulo={"Bebida"}
                            comidas={bebida}
                        />
                    </Row>
                    </Col>
                </Row>

                {/* Insumos del pedido de producto adjunto. Va al final y aparte
                    de las comidas del menú diario, igual que en el modal de
                    pedido adjunto del panel administrativo (Pedidos Adjuntos y
                    Delivery comparten ese modal).

                    La tabla aparece solo si el pedido de vianda vino con
                    insumos: la adjunción es opcional y lo normal es que no haya,
                    asi que una tabla con "No hay Insumos." seria ruido en casi
                    todos los pedidos. En el admin la tabla esta siempre porque
                    sus dos pantallas listan justamente los pedidos adjuntos. */}
                { insumosAdjuntos.length > 0 &&
                    <Row>
                        <Col className={'col-6'}>
                        <Row className={'pr-1'}>
                            <TableComidasPedidas
                                titulo={"Insumos"}
                                comidas={insumosAdjuntos}
                                conCantidad={true}
                            />
                        </Row>
                        </Col>
                    </Row>
                }
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Viandas/HistorialViandas/Modal.js